import { useTranslation } from 'react-i18next';
import { Country, DeliveryPromise } from '@steelbuy/ts-shared';
import { Card } from '../card/Card';
import { CardLayout } from '../card/card-layout/CardLayout';
import { CardContentAttributesItem } from '../card-content-attributes/card-content-attributes-item/CardContentAttributesItem';
import { CardContentAttributes } from '../card-content-attributes/CardContentAttributes';
import { CardContentMaterialLocation } from '../card-content-material-location/CardContentMaterialLocation';
import { InputRadioButton } from '../input-radio-button/InputRadioButton';
import { InputRadioButtonGroup, InputRadioButtonGroupAlign } from '../input-radio-button-group/InputRadioButtonGroup';

type CardContentCheckoutDeliveryProps = {
    deliveryPromise?: DeliveryPromise;
    onHaulierRequiredChanged: (val: boolean) => void;
    haulierRequired?: boolean;
    countryCode?: Country;
    name?: string;
};

const HaulierRequiredQuestion = ({
    name = 'radio-button-group-delivery',
    onHaulierRequiredChanged,
    haulierRequired,
}: {
    onHaulierRequiredChanged: (val: boolean) => void;
    haulierRequired?: boolean;
    name?: string;
}) => {
    const { t } = useTranslation(['uiPrimitive', 'domainModel']);

    return (
        <section className="card-content-checkout-delivery">
            <InputRadioButtonGroup
                align={InputRadioButtonGroupAlign.ALIGN_HORIZONTAL}
                label={t('checkout.delivery.haulierRequiredMessage')}
                isMandatory
            >
                <InputRadioButton
                    value={t('checkout.delivery.checkboxNo')}
                    id="radio-button-delivery-no"
                    name={name}
                    checked={!haulierRequired && haulierRequired !== undefined}
                    onChange={() => onHaulierRequiredChanged(false)}
                />
                <InputRadioButton
                    value={t('checkout.delivery.checkboxYes')}
                    id="radio-button-delivery-yes"
                    name={name}
                    checked={haulierRequired}
                    onChange={() => onHaulierRequiredChanged(true)}
                />
            </InputRadioButtonGroup>
        </section>
    );
};

export const CardContentCheckoutDelivery = ({
    deliveryPromise,
    haulierRequired,
    countryCode,
    onHaulierRequiredChanged,
    name,
}: CardContentCheckoutDeliveryProps) => {
    const { t } = useTranslation(['uiPrimitive', 'domainModel']);

    if (!deliveryPromise)
        return (
            <HaulierRequiredQuestion
                haulierRequired={haulierRequired}
                onHaulierRequiredChanged={onHaulierRequiredChanged}
                name={name}
            />
        );

    return (
        <Card isClickable={false}>
            <CardLayout>
                <CardContentAttributes header={t('checkout.delivery.title')}>
                    <CardContentAttributesItem
                        label={t('checkout.deliveryText')}
                        value={t(`domainModel:deliveryPromise.${deliveryPromise}`)}
                    />
                    {countryCode && <CardContentMaterialLocation countryCode={countryCode} />}
                </CardContentAttributes>
                <HaulierRequiredQuestion
                    haulierRequired={haulierRequired}
                    onHaulierRequiredChanged={onHaulierRequiredChanged}
                />
            </CardLayout>
        </Card>
    );
};
